import React, { forwardRef, useImperativeHandle } from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';


const MicrofonoNestedList = forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <List
      sx={{ width: '100%', maxWidth: 540, bgcolor: '#e2e2e2', alignContent: 'center'}}
      component="nav"
      aria-labelledby="nested-list-subheader"
      style={{ margin: 'auto' }}
      subheader={
        <ListSubheader component="div" id="nested-list-subheader" style={{ paddingTop: '5px'}} ></ListSubheader>
      }
      
    >
      <ListItemButton onClick={handleClick}>
        <ListItemText primary="Pruebas de micrófono" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding sx={{bgcolor:'background.paper'}}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemText primary="Acceso" />
            {props.acceso != null ? props.acceso ? <span>Ok</span>: <span>No</span> : <span>?</span>}
          </ListItemButton>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemText primary="Funcionamiento" />
            {props.funcionamiento != null ? props.funcionamiento ? <span>Ok</span>: <span>No</span> : <span>?</span>}
          </ListItemButton>
        </List>
      </Collapse>
    </List>
  );
});

export default MicrofonoNestedList;